import CardDiv from "modules/common/card-div/CardDiv";
import React from "react";
import { Col, Placeholder, Row } from "react-bootstrap";

function ProfilePlaceHolder() {
  return (
    <div style={{ height: "90vh", top: "10rem" }} className="mt-3">
      <Row className=" ms-2 me-2">
        <CardDiv
          component={
            <div>
              <Placeholder
                animation="glow"
                className="d-flex p-2 justify-content-between"
              >
                <Placeholder xs={4} bg="primary" className=" me-5" />
                <Placeholder xs={3} className=" mx-3" />
                <Placeholder.Button variant="primary" xs={1} />
                <Placeholder xs={1} />
                <Placeholder.Button variant="primary" xs={1} />
              </Placeholder>
              <Placeholder
                animation="glow"
                className="d-flex p-2 justify-content-between"
              >
                <Placeholder xs={4} className=" me-5" />
                <Placeholder xs={3} className=" mx-3" />
                <Placeholder xs={2} />
                <Placeholder.Button variant="primary" xs={1} />
              </Placeholder>

              <Placeholder
                animation="glow"
                className="d-flex p-2 justify-content-between"
              >
                <Placeholder xs={10} className=" me-1" />
                <Placeholder.Button variant="primary" className="px-1" xs={1} />
                <Placeholder.Button variant="primary" className="px-1" xs={1} />
              </Placeholder>
            </div>
          }
        />
      </Row>
      <Row
        style={{ height: "72%" }}
        className="w-100 ps-3 pt-0 d-flex gap-4 my-3"
      >
        <Col md={3} style={{ width: "24%" }} className="d-flex flex-column">
          <Row style={{ height: "30%" }} className="mb-3 ">
            <CardDiv
              component={
                <Placeholder
                  animation="glow"
                  className="border border-primary rounded h-100 p-2 d-flex flex-column justify-content-start gap-2 align-items-center"
                >
                  <Placeholder
                    xs={7}
                    size="lg"
                    bg="primary"
                    className="p-3 rounded"
                  />
                  <Placeholder xs={5} bg="secondary" className="p-3 rounded" />
                  <Placeholder
                    animation="glow"
                    className="d-flex gap-2 w-100 justify-content-center"
                  >
                    <Placeholder
                      xs={5}
                      size="lg"
                      bg="primary"
                      className="p-3 rounded"
                    />
                    <Placeholder
                      xs={5}
                      size="lg"
                      bg="primary"
                      className="p-3 rounded"
                    />
                  </Placeholder>
                </Placeholder>
              }
            />
          </Row>
          <Row style={{ height: "65%" }} className="p-0">
            <CardDiv component={<div></div>} />
          </Row>
        </Col>

        <Col
          style={{ padding: 0, width: "75%" }}
          className="d-flex flex-column gap-3 mx-3"
        >
          <Row style={{ height: "30%" }}>
            <CardDiv
              component={
                <div
                  style={{ height: "100%" }}
                  className="border d-flex border-primary  rounded"
                >
                  <Placeholder
                    style={{ width: "35%", background: "#eee" }}
                    className="d-flex flex-column gap-2 p-2"
                  >
                    <Placeholder
                      xs={3}
                      size="lg"
                      bg="info"
                      className="p-3 me-5"
                    />
                    <Placeholder
                      xs={6}
                      size="lg"
                      bg="primary"
                      className="p-3 me-5"
                    />
                  </Placeholder>
                  <div
                    style={{ width: "65%" }}
                    className="d-flex flex-column gap-2 p-2"
                  >
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={2}
                        size="lg"
                        bg="primary"
                        className="p-3 me-3"
                      />
                      <Placeholder
                        xs={2}
                        size="lg"
                        bg="primary"
                        className="p-3 me-5"
                      />
                    </Placeholder>
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={3}
                        size="lg"
                        bg="info"
                        className="p-3 me-3"
                      />
                      <Placeholder
                        xs={2}
                        size="lg"
                        bg="info"
                        className="p-3 me-3"
                      />
                      <Placeholder
                        xs={2}
                        size="lg"
                        bg="warning"
                        className="p-3 me-3"
                      />
                      <Placeholder
                        xs={1}
                        size="lg"
                        bg="warning"
                        className="p-3 me-3"
                      />
                    </Placeholder>
                    <Placeholder animation="glow">
                      <Placeholder
                        md={1}
                        size="lg"
                        bg="info"
                        className="p-3 me-2"
                      />
                      <Placeholder
                        md={1}
                        size="lg"
                        bg="secondary"
                        className="p-3 me-2"
                      />
                      <Placeholder
                        md={1}
                        size="lg"
                        bg="info"
                        className="p-3 me-2"
                      />
                    </Placeholder>
                  </div>
                </div>
              }
            />
          </Row>
          <Row style={{ height: "65%" }}>
            <CardDiv
              component={
                <div>
                  <Placeholder
                    animation="glow"
                    className="d-flex flex-column p-2"
                  >
                    <Placeholder animation="glow" className="d-flex gap-4">
                      <Placeholder.Button
                        variant="primary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                      <Placeholder.Button
                        variant="secondary"
                        className="px-1"
                        xs={1}
                      />{" "}
                    </Placeholder>
                    <hr />

                    <CardDiv
                      title={
                        <Placeholder animation="glow" className="d-flex gap-4 ">
                          <Placeholder.Button
                            variant="primary"
                            className="px-1"
                            xs={1}
                          />{" "}
                          <Placeholder.Button
                            variant="secondary"
                            className="px-1"
                            xs={1}
                          />{" "}
                          <Placeholder.Button
                            variant="secondary"
                            className="px-1"
                            xs={1}
                          />{" "}
                          <Placeholder.Button
                            variant="secondary"
                            className="px-1"
                            xs={1}
                          />{" "}
                          <Placeholder.Button
                            variant="secondary"
                            className="px-1"
                            xs={1}
                          />{" "}
                        </Placeholder>
                      }
                      component={
                        <div className="d-flex flex-column">
                          <Placeholder className="border p-2 my-2"></Placeholder>
                          <Placeholder className="border p-2 my-2"></Placeholder>
                          <Placeholder className="border p-2 my-2"></Placeholder>
                          <Placeholder className="border p-2 my-2"></Placeholder>
                        </div>
                      }
                    />
                  </Placeholder>
                </div>
              }
            />
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default ProfilePlaceHolder;
